import React, { useEffect } from 'react';
import { AnalyticsEventActions, AnalyticsEventSource, sanitiseValue, useAnalytics, usePrincipalUser } from '@atlassian/ptc-common';
import { Redirect } from '../components/Router';
export default function MyProfileRedirect(props) {
  const {
    contextEntryPoint,
    location
  } = props;
  const [{
    principalUserId
  }] = usePrincipalUser();
  const analytics = useAnalytics();
  const url = new URL(window.location.href);
  const ref = sanitiseValue(url.searchParams.get('ref') || '', {
    shouldHaveSafeCharsOnly: true,
    shouldEncode: true
  });
  useEffect(() => {
    analytics.pushTrackEvent({
      source: AnalyticsEventSource.USER_PROFILE_SCREEN,
      actionSubject: 'redirectMePathToMyProfile',
      action: AnalyticsEventActions.REDIRECTED,
      attributes: {
        ref
      }
    });
  }, [analytics, ref]);
  if (!principalUserId) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Redirect, {
    to: `${contextEntryPoint}/${principalUserId}${location.search}`
  });
}